import React, { useEffect, useState } from "react";

import { Button, Stack } from "react-bootstrap";

import HeaderRegistration from "../../components/headerRegistration/HeaderRegistration";
import GoBack from "../../components/goBack/GoBack";
import ListTopic from "../../../../components/listTopic/ListTopic";

import { t } from "i18next";
import { topicWS } from "../../api/registrationApi";
import { isEmpty } from "../../../../utils/validation";

const StepAssociation3 = ({
  selectedAssociationTopic,
  setSelectedAssociationTopic,
  nextStep,
  previousStep,
  save = false,
}) => {
  const [listTopic, setListTopic] = useState([]);

  useEffect(() => {
    topicWS().then((res) => setListTopic(res));
  }, []);

  return (
    <Stack gap={4} className="py-2 container-customize-preference">
      <Stack
        gap={3}
        className="d-flex justify-content-center align-items-center w-100 customize-preference"
      >
        <HeaderRegistration
          colorTitle="#4190A3"
          colorSubtitle="#000"
          textAlign="center"
          title={t("registration.title_association_topic")}
          subtitle={t("registration.subtitle_association_topic")}
        />
        {!isEmpty(listTopic) ? (
          <ListTopic
            data={listTopic}
            title={t("registration.what_topic")}
            textColor={"#000"}
            disabled={false}
            selected={selectedAssociationTopic}
            setSelected={setSelectedAssociationTopic}
            width={310}
          />
        ) : null}
        <Button
          variant="success"
          size="md"
          className="button-registration"
          style={{ width: 310 }}
          onClick={() => {
            nextStep();
          }}
        >
          {save ? t("common.save") : t("common.next")}
        </Button>
      </Stack>
      <GoBack color="black" previousStep={previousStep} />
    </Stack>
  );
};

export default StepAssociation3;
